<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <div class="d-flex align-items-center mr-3" style="gap: 10px;">
              <form [formGroup]="filterForm" (ngSubmit)="onFilterBy()" class="d-flex gap-3 items-center" style="gap: 10px;" >
                <div class="d-flex flex-column">
                  <label for="status">Filter by</label>
                  <select name="status" id="status"  formControlName="status" class="form-control">
                    <option *ngFor="let f of filterZoneBy" [value]="f.value">{{f.name}}</option>
                  </select>
                </div>
                <div class="align-self-end">
                  <button class="btn btn-primary" [disabled]="filterForm.invalid" type="submit">Filter</button>
                </div>
              </form>
            </div>
            <!--<h2>Manage Super Agents</h2>-->
            <div class="float-right">
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="openDialog('createSuperAgent')">
                <i class="fa fa-plus"></i> &nbsp;<span>New Super Agent</span></button>
            </div>
          </div>
          <div class="body mt-2">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive" *ngIf="!loadingData">
              <table id="super-agents-list" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort"></th>

                  <th>S/N</th>
                  
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Zone</th>
                  <th>Code</th>
                  <th>Wallet Bal.</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>S/N</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th>Zone</th>
                  <th>Code</th>
                  <th>Wallet Bal.</th>
                  <th>Action</th>
                </tr>
                </tfoot>
                <tbody>

                <tr *ngFor="let sAgent of allSuperAgents;let i = index;">
                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                  <td>{{ sAgent?.first_name }}</td>
                  <td>{{ sAgent?.last_name }}</td>
                  <td>{{ sAgent?.email }}</td>
                  <td>{{ sAgent?.phone_no }}</td>
                  <td>{{ sAgent?.zone?.name }}</td>
                  <td>{{ sAgent?.unique_code }}</td>
                  <th>{{ sAgent?.wallet || 0 | currency: '&#8358;'}}</th>
                  
                  <td>
                    <div >
                      <span role="button" data-balloon="Edit Super Agent" data-balloon-pos="up" (click)="triggerEdit(sAgent)">
                        <i class="fa fa-edit text-info"></i>
                      </span>&nbsp;&nbsp;
                      <button role="button" 
                        [disabled]="disabled && superAgentId === sAgent.id"
                        [attr.data-balloon]="sAgent.status == 'Active' ? 'Disable Super Agent' : 'Enable Super Agent' "
                        data-balloon="Disable Super Agent" 
                        data-balloon-pos="up" 
                        (click)="toggleSuperAgentStatus(sAgent)"
                        [ngClass]="sAgent.status === 'Active' ? 'btn-danger' : 'btn-success' "
                        class="btn btn-sm">
                        {{ sAgent.status === 'Active' ? 'Disable' : 'Enable'}}
                      </button>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>



<!-- modal -->
<app-modal [modalId]="'createSuperAgent'" [modalTitle]="modal.title" >
    <form class="form-auth-small" #signupForm="ngForm" (ngSubmit)="createSuperAgent()">

    <div class="modal-body">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <label for="first_name" class="control-label">First Name</label>
            <input type="text" class="form-control" placeholder="First Name"
                   #first_name="ngModel"
                   id="first_name"
                   [(ngModel)]="superAgent.first_name" [ngModelOptions]="{standalone: true}" required>
            <div class="text-danger" *ngIf="first_name.errors && (first_name.dirty || first_name.touched)">
                  <span class="validation-message" [hidden]="!first_name.hasError('required')">
                    First name is required</span>
            </div>
          </div>
          <div class="form-group">
            <label for="email" class="control-label">Email</label>
            <input type="email" class="form-control" placeholder="Email"
                   #email="ngModel"
                   id="email"
                   [(ngModel)]="superAgent.email" [ngModelOptions]="{standalone: true}" [pattern]="EMAIL_VALIDATION" required>
            <div class="text-danger" *ngIf="email.errors && (email.dirty || email.touched)">
                  <span class="validation-message" [hidden]="!email.hasError('required')">
                    Email is required</span>
              <span class="validation-message" [hidden]="!email.hasError('pattern')">
                    Invalid Email</span>
            </div>
          </div>

        </div>


        <div class="col-sm-12 col-md-6">
          <div class="form-group">
            <label for="last_name" class="control-label">Last Name</label>
            <input type="text" class="form-control" placeholder="Last Name"
                   #last_name="ngModel"
                   id="last_name"
                   [(ngModel)]="superAgent.last_name" [ngModelOptions]="{standalone: true}" required>
            <div class="text-danger" *ngIf="last_name.errors && (last_name.dirty || last_name.touched)">
                  <span class="validation-message" [hidden]="!last_name.hasError('required')">
                    Last name is required</span>
            </div>
          </div>
          <div class="form-group">
            <label for="phone_number" class="control-label">Phone Number</label>
            <input type="text" class="form-control" placeholder="Phone Number"
                   #phone_number="ngModel"
                   id="phone_number" maxlength="11"
                   [(ngModel)]="superAgent.phone_no" [ngModelOptions]="{standalone: true}" pattern="^[0-9]{11}$" required>
            <div class="text-danger" *ngIf="phone_number.errors && (phone_number.dirty || phone_number.touched)">
                  <span class="validation-message" [hidden]="!phone_number.hasError('required')">
                    Phone is required</span>
                  <span class="validation-message" *ngIf="phone_number.hasError('pattern')">
                    Phone number must be exactly 11 digits.</span>
            </div>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="selectZone" class="control-label">Select Zone</label>
            <ng-select [items]="allZones" class="ng-select-form" #zone_id="ngModel" required id="selectZone"
                       [notFoundText]="'No data available'"
                       [placeholder]="'Select Zone'"
                       bindLabel="name"
                       bindValue="id"
                       [multiple]="false"
                       [(ngModel)]="superAgent.zone_id" [ngModelOptions]="{standalone: true}" >
            </ng-select>

            <div class="text-danger" *ngIf="zone_id.errors && (zone_id.dirty || zone_id.touched)">
                  <span class="validation-message" [hidden]="!zone_id.hasError('required')">
                    Zone is required</span>
            </div>
          </div>
        </div>

      </div>
      </div>
      <div class="modal-footer">
        <button type="submit" *ngIf="!loaders.saving" [disabled]="first_name.errors || last_name.errors || email.errors || zone_id.errors || loaders.saving" class="btn btn-primary">{{modal.btnText}}</button>
        <span *ngIf="loaders.saving" [disabled]="loaders.saving" class="btn btn-primary">Loading&nbsp;<i class="fa fa-spin fa-spinner"></i></span>
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="resetForm()">CLOSE</button>
      </div>
    </form>
</app-modal>
